__turbopack_context__.v({
  "moreButton": "SearchResults-module-scss-module__ri35iG__moreButton",
  "noResults": "SearchResults-module-scss-module__ri35iG__noResults",
  "result": "SearchResults-module-scss-module__ri35iG__result",
  "title": "SearchResults-module-scss-module__ri35iG__title",
  "wrapper": "SearchResults-module-scss-module__ri35iG__wrapper",
});
